import { v4 as uuidv4 } from 'uuid';
import ServiceLocator from "../../../global/service-locator";
import {AnalyticsService} from "../../../services/analytics-service";
import EnvHelper from "../../../lib/env-helper";
import FormEventSubscription from "../../../components/base/form-v2/form-event-subscription";
import Form from "../../../components/base/form-v2/form";

export default class FormController {
	constructor() {
		this.sl = ServiceLocator.instance;
		this.sidFid = AnalyticsService.getFidCid();

		this.init();
	}

	init() {
		// this.initConsultationForm();
		this.initConsultationStaticForm();
	}

	// initConsultationForm() {
	// 	this.consultationForm = new ModalForm({
	// 		id: 'consultation',
	// 		path: '/2.0/courses/registration',
	// 		hash: 'consultation',
	// 		data: {
	// 			type: 'consultation',
	// 			course: EnvHelper.page.courseDirectoryId,
	// 			fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
	// 			fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
	// 			cid: this.sidFid.cid,
	// 			fid: this.sidFid.fid,
	// 			referrer: location.href
	// 		},
	// 		$modalTriggers: Array.from(document.querySelectorAll('.btn-consultation')),
	// 		afterOpen: () => {
	// 			/* FB Analytics data for backend */
	// 			if (EnvHelper.page.handle === 'courses-entry') {
	// 				if (EnvHelper.page.coursesStatsConfig &&
	// 					EnvHelper.page.coursesStatsConfig.entryId
	// 				) {
	// 					Api.sendFbEvent('AddToCart', {
	// 						entryId: EnvHelper.page.coursesStatsConfig.entryId
	// 					});
	// 				} else {
	// 					console.error('Api/fbq: entryId is not defined');
	// 				}
	// 			}
	// 		},
	// 		subscriptions: [
	// 			new FormEventSubscription({
	// 				field: 'course',
	// 				event: 'getEntryIdOnValueChange',
	// 				callback: (value) => {
	// 					/* FB Analytics */
	// 					Api.sendFbEvent('AddToCart', {
	// 						entryId: value
	// 					});
	// 				}
	// 			}),
	// 			new FormEventSubscription({
	// 				event: 'beforeSubmit',
	// 				callback: () => {
	// 					const courseLang = this.sl.courseLang;
	// 					const conversionId = uuidv4();
	// 					const owoxUserId = costorage.get('ouid');
	//
	//
	// 					if (courseLang) {
	// 						this.consultationForm.controller.updateData({ courseLang });
	// 					}
	//
	// 					this.consultationForm.controller.updateData({ conversionId });
	//
	// 					if (owoxUserId) {
	// 						this.consultationForm.controller.updateData({ owoxUserId });
	// 					}
	//
	// 					const submitData = this.consultationForm.controller.getSubmitData();
	// 					const dataLayerEventData = {
	// 						event: 'free_consultation_form',
	// 						formId: this.consultationForm.id,
	// 						phone: submitData.body.tel,
	// 						email: submitData.body.email,
	// 						conversion_id: conversionId
	// 					};
	//
	// 					const $formTitle = this.consultationForm.$root.querySelector('.f-title');
	//
	// 					if ($formTitle) {
	// 						dataLayerEventData.formName = $formTitle.textContent;
	// 					}
	//
	// 					AnalyticsService.sendEvent('free_consultation_form', dataLayerEventData);
	// 				}
	// 			}),
	// 			new FormEventSubscription({
	// 				event: 'submitComplete',
	// 				callback: () => {
	// 					costorage.set('h_consultationRequested', 1, {
	// 						expires: 45 * 24 * 60 * 60,
	// 						domain: EnvHelper.env.isInternational ? '.ithillel.com' : '.ithillel.ua',
	// 						path: "/"
	// 					});
	// 				}
	// 			})
	// 		]
	// 	})
	// }

	initConsultationStaticForm() {
		this.consultationStaticForm = new Form({
			id: 'consultation-static',
			path: '/2.0/courses/registration',
			data: {
				type: 'consultation',
				course: EnvHelper.page.courseDirectoryId,
				cid: this.sidFid.cid,
				fid: this.sidFid.fid,
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null
			},
			subscriptions: [
				new FormEventSubscription({
					event: 'beforeSubmit',
					callback: () => {
						const courseLang = this.sl.courseLang;
						const conversionId = uuidv4();
						const owoxUserId = costorage.get('ouid');


						if (courseLang) {
							this.consultationStaticForm.controller.updateData({ courseLang });
						}

						this.consultationStaticForm.controller.updateData({ conversionId });

						if (owoxUserId) {
							this.consultationStaticForm.controller.updateData({ owoxUserId });
						}

						const submitData = this.consultationStaticForm.controller.getSubmitData();
						const dataLayerEventData = {
							event: 'free_consultation_footer_form',
							formId: this.consultationStaticForm.id,
							phone: submitData.body.tel,
							email: submitData.body.email,
							conversion_id: conversionId
						};

						const $formTitle = this.consultationStaticForm.$root.querySelector('.f-title');

						if ($formTitle) {
							dataLayerEventData.formName = $formTitle.textContent;
						}

						AnalyticsService.sendEvent('free_consultation_footer_form', dataLayerEventData);
					}
				}),
				new FormEventSubscription({
					event: 'submitComplete',
					callback: () => {
						costorage.set('h_consultationRequested', 1, {
							expires: 45 * 24 * 60 * 60,
							domain: EnvHelper.env.isInternational ? '.ithillel.com' : '.ithillel.ua',
							path: "/"
						});
					}
				})
			]
		});
	}
}